import { CloudForwarderForwarderInput } from "@graylog/enterprise-api";
const fetchForwarderInput = (inputId) => CloudForwarderForwarderInput.getById(encodeURIComponent(inputId));
export default fetchForwarderInput;
